import { Injectable } from "@angular/core";
import { MeasurementContext, SiUnits, UnitType, UnitTypeDescriptions, UsUnits } from "../data/engineering-enums";

@Injectable({
  providedIn: 'root', // Singleton
})
export class UnitConverterService {

  public IsUsUnits: boolean = true;

  FormatUs(value: any, context: MeasurementContext, decimalPlaces: number, includeUnits: boolean = true): string {
    if (value === null || value === undefined || value.Value === undefined || value.Unit === undefined) {
      return '';
    }
    let displayUnit = UsUnits.get(context) || UnitType.F;
    return this.Convert(value.Unit, displayUnit, value.Value)
      .toFixed(decimalPlaces) + (includeUnits ? ' ' + (UnitTypeDescriptions.get(displayUnit) || '') : '');
  }

  FormatSi(value: any, context: MeasurementContext, decimalPlaces: number, includeUnits: boolean = true): string {
    if (value === null || value === undefined || value.Value === undefined || value.Unit === undefined) {
      return '';
    }
    let displayUnit = SiUnits.get(context) || UnitType.C;
    return this.Convert(value.Unit, displayUnit, value.Value)
      .toFixed(decimalPlaces) + (includeUnits ? ' ' + (UnitTypeDescriptions.get(displayUnit) || '') : '');
  }

  GetUnitText(unitType: number): string {
    return UnitTypeDescriptions.get(unitType) || '';
  }

  Convert(fromUnits: UnitType, toUnits: UnitType, value: number, value2: number = 0): number {
    if (fromUnits === toUnits) return value;

            //returns -999 if no equation exists
            switch (fromUnits)
            {
                //Farenheit
                case UnitType.F:
                    switch (toUnits)
                    {
                        case UnitType.C:
                            return (value - 32) / 1.8;

                        case UnitType.K:
                            return ((value - 32) / 1.8) + 273.15;

                        default:
                            return -999;
                    }

                //Celcius
                case UnitType.C:
                    switch (toUnits)
                    {
                        case UnitType.F:
                            return (value * 1.8) + 32;

                        case UnitType.K:
                            return value + 273.15;

                        default:
                            return -999;
                    }

                //Kelvin
                case UnitType.K:
                    switch (toUnits)
                    {
                        case UnitType.F:
                            return ((value - 273.15) * 1.8) + 32;

                        case UnitType.C:
                            return value - 273.15;

                        case UnitType.Rankine:
                            return value / 1.8;

                        default:
                            return -999;
                    }

                //Rankine
                case UnitType.Rankine:
                    switch (toUnits)
                    {
                        case UnitType.K:
                            return value * 1.8;

                        default:
                            return -999;
                    }
                    
                // PSI
                case UnitType.Psi:
                case UnitType.Psia:
                    switch (toUnits)
                    {
                        case UnitType.kpa:
                            return value * 6.894757;

                        case UnitType.KgCm2a:
                        case UnitType.KgCm2:
                            return value * .07030696;

                        case UnitType.barA:
                        case UnitType.bar:
                            return value * .0689475729;

                        case UnitType.Psi:
                        case UnitType.Psia:
                            return value;

                        case UnitType.Psig:
                            return value - 14.5037738;

                        default:
                            return -999;
                    }

                case UnitType.Psig:
                    switch (toUnits)
                    {
                        case UnitType.barG:
                            return value * .0689475729;

                        case UnitType.Psig:
                            return value;

                        case UnitType.Psia:
                            return value + 14.5037738;

                        default:
                            return -999;
                    }

                // KG/CM²
                case UnitType.KgCm2:
                case UnitType.KgCm2a:
                    switch (toUnits)
                    {
                        case UnitType.Psia:
                        case UnitType.Psi:
                        case UnitType.Psig:
                            return value * 14.22334;

                        case UnitType.barA:
                        case UnitType.bar:
                        case UnitType.barG:
                            return value * .980665;

                        case UnitType.kpa:
                            return value * 98.0665;

                        case UnitType.KgCm2a:
                        case UnitType.KgCm2:
                            return value;

                        default:
                            return -999;
                    }

                // BAR
                case UnitType.barA:
                case UnitType.bar:
                    switch (toUnits)
                    {
                        case UnitType.Psi:
                            return value * 14.5037738;

                        case UnitType.kpa:
                            return value * 100;

                        case UnitType.KgCm2a:
                        case UnitType.KgCm2:
                            return value * 1.019716;

                        case UnitType.Psia:
                            return value * 14.50377;

                        case UnitType.barA:
                        case UnitType.bar:
                            return value;

                        case UnitType.barG:
                            return value - 1;

                        default:
                            return -999;
                    }

                case UnitType.barG:
                    switch (toUnits)
                    {
                        case UnitType.Psig:
                            return value * 14.50377;

                        case UnitType.barG:
                            return value;

                        case UnitType.barA:
                            return value + 1;

                        default:
                            return -999;
                    }

                // kPa
                case UnitType.kpa:
                    switch (toUnits)
                    {
                        case UnitType.Psia:
                        case UnitType.Psi:
                            return value * 0.1450377;

                        case UnitType.barA:
                        case UnitType.bar:
                            return value * .01;

                        case UnitType.KgCm2a:
                        case UnitType.KgCm2:
                            return value * 0.01019716;

                        default:
                            return -999;
                    }
                    
                case UnitType.ft2hFBTU:
                    switch (toUnits)
                    {
                        case UnitType.m2KW:
                            return value * 0.1761;
                        default:
                            return -999;
                    }
                case UnitType.m2KW:
                    switch (toUnits)
                    {
                        case UnitType.ft2hFBTU:
                            return value * 5.6785;
                        default:
                            return -999;
                    }
                    
                case UnitType.m2:
                    switch (toUnits)
                    {
                        case UnitType.ft2:
                            return value * 10.7639;

                        default:
                            return -999;
                    }

                // ms to Current
                case UnitType.ft2:
                    switch (toUnits)
                    {
                        case UnitType.m2:
                            return value * 0.092903;

                        default:
                            return -999;
                    }

                // ms to Current
                case UnitType.ms:
                    switch (toUnits)
                    {
                        case UnitType.fts:
                            return value * 3.2808;

                        case UnitType.ftm:
                            return value * 196.85;

                        default:
                            return -999;
                    }

                // fts to Current
                case UnitType.fts:
                    switch (toUnits)
                    {
                        case UnitType.ms:
                            return value * 0.3048;

                        case UnitType.ftm:
                            return value * 60;

                        default:
                            return -999;
                    }

                case UnitType.ftm:
                    switch (toUnits)
                    {
                        case UnitType.ms:
                            return value * 0.00508;

                        case UnitType.fts:
                            return value * 0.0166667;

                        default:
                            return -999;
                    }

                // BTUlbF to Current
                case UnitType.BTUlbF:
                // BTUlbR to Current
                case UnitType.BTUlbR:
                    switch (toUnits)
                    {
                        case UnitType.BTUlbR:
                        case UnitType.BTUlbF:
                        case UnitType.kcalKgC:
                            return value * 1;

                        case UnitType.kJkgK:
                            return value * 4.186799993;

                        case UnitType.JkgK:
                            return value * 4186.799993;

                        default:
                            return -999;
                    }

                // kcalKgC to Current
                case UnitType.kcalKgC:
                    switch (toUnits)
                    {
                        case UnitType.BTUlbR:
                        case UnitType.BTUlbF:
                            return value * 1;

                        case UnitType.kJkgK:
                            return value * 4.1868;

                        case UnitType.JkgK:
                            return value * 4186.8;

                        default:
                            return -999;
                    }

                // Jkg K to Current
                case UnitType.JkgK:
                    switch (toUnits)
                    {
                        case UnitType.BTUlbR:
                        case UnitType.BTUlbF:
                        case UnitType.kcalKgC:
                            return value * 0.000238846;

                        case UnitType.kJkgK:
                            return value * 0.001;

                        default:
                            return -999;
                    }

                // kJkg K to Current
                case UnitType.kJkgK:
                    switch (toUnits)
                    {
                        case UnitType.BTUlbR:
                        case UnitType.BTUlbF:
                        case UnitType.kcalKgC:
                            return value * .238846;

                        case UnitType.JkgK:
                            return value * 1000;

                        default:
                            return -999;
                    }

                // kW to Current
                case UnitType.kW:
                    switch (toUnits)
                    {
                        case UnitType.TR:
                            return value / 3.5172;

                        case UnitType.HP:
                        case UnitType.BHP:
                            return value * 1.34102209;

                        case UnitType.MBH:
                            return value / 0.2931;

                        case UnitType.Mkcalh:
                            return value * 1164.635761589404;

                        case UnitType.kcalh:
                            return value * 859.845227859;

                        default:
                            return -999;
                    }

                // TR (Tons of Refrigeration) to Current
                case UnitType.TR:
                    switch (toUnits)
                    {
                        case UnitType.Mkcalh:
                            return value * .00302;

                        case UnitType.kW:
                            return value * 3.5172;

                        default:
                            return -999;
                    }

                // Mkcalh to Current
                case UnitType.Mkcalh:
                    switch (toUnits)
                    {
                        case UnitType.TR:
                            return value / .00302;

                        case UnitType.kW:
                            return value / 1164.635761589404;

                        default:
                            return -999;
                    }

                // BHP/HP to Current
                case UnitType.HP:
                case UnitType.BHP:
                    switch (toUnits)
                    {
                        case UnitType.kW:
                            return value * 0.745699872;

                        case UnitType.HP:
                        case UnitType.BHP:
                            return value;

                        default:
                            return -999;
                    }

                // lbMin to Current
                case UnitType.lbMin:
                    switch (toUnits)
                    {
                        case UnitType.kgH:
                            return value * 27.2154;

                        default:
                            return -999;
                    }

                // kgH to Current
                case UnitType.kgH:
                    switch (toUnits)
                    {
                        case UnitType.lbMin:
                            return value * .03674371;

                        default:
                            return -999;
                    }

                // lbFt to Current
                case UnitType.lbFt:
                    switch (toUnits)
                    {
                        case UnitType.Kgm:
                            return value * .13825;

                        case UnitType.Nm:
                            return value * 1.356;

                        default:
                            return -999;
                    }

                // Kgm to Current
                case UnitType.Kgm:
                    switch (toUnits)
                    {
                        case UnitType.lbFt:
                            return value / .13825;

                        default:
                            return -999;
                    }

                // Nm to Current
                case UnitType.Nm:
                    switch (toUnits)
                    {
                        case UnitType.lbFt:
                            return value / 1.356;

                        default:
                            return -999;
                    }

                // GPM to Current
                case UnitType.GPM:
                    switch (toUnits)
                    {
                        case UnitType.GPH:
                            return value * 60;

                        case UnitType.lm:
                            return value * 3.785412;

                        case UnitType.m3h:
                            return value * 3.785412 * 60 / 1000;

                        case UnitType.m3s:
                            return value * 3.785412 / 60 / 1000;

                        case UnitType.lSec:
                            return value * .06309;

                        default:
                            return -999;
                    }

                // lm to Current
                case UnitType.lm:
                    switch (toUnits)
                    {
                        case UnitType.GPH:
                            return value * 15.8503;

                        case UnitType.GPM:
                            return value * .2641721;

                        case UnitType.lSec:
                            return value / 60;

                        default:
                            return -999;
                    }

                // lSec to Current
                case UnitType.lSec:
                    switch (toUnits)
                    {
                        case UnitType.GPH:
                            return value * 951.019;

                        case UnitType.GPM:
                            return value / .06309;

                        case UnitType.lm:
                            return value * 60;

                        default:
                            return -999;
                    }

                // gal/hr to Current
                case UnitType.GPH:
                    switch (toUnits)
                    {
                        case UnitType.lSec:
                            return value * 0.0010515;

                        case UnitType.GPM:
                            return value / 60;

                        case UnitType.lm:
                            return value * 0.0630902;

                        default:
                            return -999;
                    }

                // MBH to Current
                case UnitType.MBH:
                    switch (toUnits)
                    {
                        case UnitType.kcalh:
                            return value * 252;

                        case UnitType.kW:
                            return value * .2931;

                        default:
                            return -999;
                    }

                // kcalh to Current
                case UnitType.kcalh:
                    switch (toUnits)
                    {
                        default:
                            return -999;
                    }

                // Jmol to Current
                case UnitType.Jmol:
                    switch (toUnits)
                    {
                        case UnitType.Btu:
                            //Jmol / mweight * .43021 (.42992)
                            return (value / value2) * .43021;

                        case UnitType.kg:
                            //JMol / mweight
                            return value / value2;

                        default:
                            return -999;
                    }

                // Btu to Current
                case UnitType.Btu:
                    switch (toUnits)
                    {
                        case UnitType.Jmol:
                            return (value * value2) / .43021;

                        default:
                            return -999;
                    }

                // molL to Current
                case UnitType.molL:
                    switch (toUnits)
                    {
                        case UnitType.kgM3:
                            //molL / mweight
                            //density in kg/m3
                            return (value * value2);

                        case UnitType.LbmFt:
                            //molL * mweight * .062428
                            //density in lbm ft3
                            return (value * value2) * .062428;

                        default:
                            return -999;
                    }

                // LbmFt to Current
                case UnitType.LbmFt:
                    switch (toUnits)
                    {
                        case UnitType.molL:
                            return (value / value2) / .062428;

                        default:
                            return -999;
                    }

                // kg/m3 to Current
                case UnitType.kgM3:
                    switch (toUnits)
                    {
                        case UnitType.lbft3:
                            return value * .062428;

                        default:
                            return -999;
                    }

                // LbmFt to Current
                case UnitType.lbft3:
                    switch (toUnits)
                    {
                        case UnitType.kgM3:
                            return value / .062428;

                        default:
                            return -999;
                    }

                // lb to Current
                case UnitType.lb:
                    switch (toUnits)
                    {
                        case UnitType.kg:
                            return value * .4536;

                        default:
                            return -999;
                    }

                // kg to Current
                case UnitType.kg:
                    switch (toUnits)
                    {
                        case UnitType.lb:
                            return value / .4536;

                        default:
                            return -999;
                    }

                // inches to Current
                case UnitType.inches:
                    switch (toUnits)
                    {
                        case UnitType.cm:
                            return value * 2.54;

                        case UnitType.mm:
                            return value * 25.4;

                        case UnitType.Dn:
                            return this.InchesToDn(value);

                        case UnitType.Ft:
                            return value / 12;

                        default:
                            return -999;
                    }

                // Dn to Current
                case UnitType.Dn:
                    switch (toUnits)
                    {
                        case UnitType.inches:
                            return this.DnToInches(value);
                        default:
                            return -999;
                    }

                // cm to Current
                case UnitType.cm:
                    switch (toUnits)
                    {
                        case UnitType.inches:
                            return value * 0.393700787;

                        case UnitType.mm:
                            return value * 10;

                        default:
                            return -999;
                    }

                // mm to Current
                case UnitType.mm:
                    switch (toUnits)
                    {
                        case UnitType.inches:
                            return value / 25.4;

                        case UnitType.cm:
                            return value / 10;

                        default:
                            return -999;
                    }

                // cfm to Current
                case UnitType.cfm:
                    switch (toUnits)
                    {
                        case UnitType.m3h:
                            return value * 1.699;

                        case UnitType.m3s:
                            return value * 1.699 / 3600;

                        case UnitType.c3h:
                            return value * 1.699 * 1000000;

                        case UnitType.i3h:
                            return value * 103680;

                        default:
                            return -999;
                    }

                // m3h to Current
                case UnitType.m3h:
                    switch (toUnits)
                    {
                        case UnitType.cfm:
                            return value * .58858;

                        case UnitType.c3h:
                            return value * 1000000;

                        case UnitType.i3h:
                            return value * 61023.74409174;

                        case UnitType.lm:
                            return value * 16.666667;

                        case UnitType.GPM:
                            return value * 4.402868;

                        case UnitType.m3s:
                            return value / 60 / 60;

                        default:
                            return -999;
                    }

                // m3s to Current
                case UnitType.m3s:
                    switch (toUnits)
                    {
                        case UnitType.GPM:
                            return value * 4.402868 * 60 * 60;

                        case UnitType.m3h:
                            return value * 60 * 60;

                        case UnitType.cfm:
                            return value * .58858 * 3600;

                        default:
                            return -999;
                    }

                // c3h to Current
                case UnitType.c3h:
                    switch (toUnits)
                    {
                        case UnitType.cfm:
                            return value / 1000000 * .58858;

                        case UnitType.m3h:
                            return value / 1000000;

                        case UnitType.i3h:
                            return value * 0.061023744;

                        default:
                            return -999;
                    }

                // i3h to Current
                case UnitType.i3h:
                    switch (toUnits)
                    {
                        case UnitType.c3h:
                            return value / 0.061023744;

                        case UnitType.m3h:
                            return value / 61023.74409174;

                        case UnitType.cfm:
                            return value / 103680;

                        default:
                            return -999;
                    }

                // Gal to Current
                case UnitType.gal:
                    switch (toUnits)
                    {
                        case UnitType.l:
                            return value * 3.785412;

                        default:
                            return -999;
                    }

                // Liter to Current
                case UnitType.l:
                    switch (toUnits)
                    {
                        case UnitType.gal:
                            return value * .2641721;

                        default:
                            return -999;
                    }

                // Ft to Current
                case UnitType.Ft:
                    switch (toUnits)
                    {
                        case UnitType.m:
                            return value * .3048;

                        case UnitType.inches:
                            return value * 12;

                        default:
                            return -999;
                    }

                // m to Current
                case UnitType.m:
                    switch (toUnits)
                    {
                        case UnitType.Ft:
                            return value * 3.2808399;

                        case UnitType.inches:
                            return value * 3.2808399 * 12;
                        case UnitType.cm:
                            return value * 100;
                        case UnitType.mm:
                            return value * 1000;

                        default:
                            return -999;
                    }

                // ft3/lb to Current
                case UnitType.ft3lbm:
                    {
                        switch (toUnits)
                        {
                            case UnitType.m3Kg:
                                return value / 16.01846338002905;

                            default:
                                return -999;
                        }
                    }

                // m3/Kg to current
                case UnitType.m3Kg:
                    switch (toUnits)
                    {
                        case UnitType.ft3lbm:
                            return value * 16.01846338002905;

                        default:
                            return -999;
                    }

                case UnitType.uPa_s:
                    {
                        switch (toUnits)
                        {
                            case UnitType.lbmFt_s:
                                return (value / 1.48816) * .000001;

                            default:
                                return -999;
                        }
                    }

                // BTUlbF to Current
                case UnitType.BTUlb:
                    switch (toUnits)
                    {
                        case UnitType.kcalKg:
                            return value / 1.79879622;

                        case UnitType.kJkg:
                            return value * 2.326000292;

                        case UnitType.Jkg:
                            return value * 2326.000292;

                        default:
                            return -999;
                    }

                // kcal/Kg to Current
                case UnitType.kcalKg:
                    switch (toUnits)
                    {
                        case UnitType.BTUlb:
                            return value * 1.79879622;

                        case UnitType.kJkg:
                            return value * 4.186799993;

                        case UnitType.Jkg:
                            return value * 4186.799993;

                        default:
                            return -999;
                    }

                // BTU/h to Current
                case UnitType.BTUh:
                    switch (toUnits)
                    {
                        case UnitType.kcalh:
                            return value * 0.251995761;

                        default:
                            return -999;
                    }

                case UnitType.DeltaF:
                    switch (toUnits)
                    {
                        case UnitType.DeltaK:
                        case UnitType.DeltaC:
                            return value * 5 / 9;

                        default:
                            return -999;
                    }

                case UnitType.DeltaK:
                case UnitType.DeltaC:
                    switch (toUnits)
                    {
                        case UnitType.DeltaF:
                            return value * 9 / 5;

                        case UnitType.DeltaC:
                            return value;

                        default:
                            return -999;
                    }

                // kg.m2 to Current
                case UnitType.kgm2:
                    switch (toUnits)
                    {
                        case UnitType.lbft2:
                            return value * 23.7529;

                        default:
                            return -999;
                    }

                // lb-ft2 to Current
                case UnitType.lbft2:
                    switch (toUnits)
                    {
                        case UnitType.kgm2:
                            return value * .0421;

                        default:
                            return -999;
                    }

                // J/kg to Current
                case UnitType.Jkg:
                    switch (toUnits)
                    {
                        case UnitType.BTUlb:
                            return value * .0004299226;

                        case UnitType.kcalKg:
                            return value * 0.0002388459;

                        case UnitType.kJkg:
                            return value * 0.001;
                        default:
                            return -999;
                    }

                case UnitType.kJkg:
                    switch (toUnits)
                    {
                        case UnitType.BTUlb:
                            return value * 0.429923;

                        case UnitType.kcalKg:
                            return value * 0.238846;

                        case UnitType.Jkg:
                            return value * 1000;
                        default:
                            return -999;
                    }

                case UnitType.BtuHrFtF:
                    switch (toUnits)
                    {
                        case UnitType.WmK:
                            return value * 1.7295772056;

                        default:
                            return -999;
                    }

                case UnitType.WmK:
                    switch (toUnits)
                    {
                        case UnitType.BtuHrFtF:
                            return value * 0.5781759824;

                        default:
                            return -999;
                    }

                case UnitType.Cp:
                    switch (toUnits)
                    {
                        case UnitType.LbFtHr:
                            return value * 2.419088310502;

                        default:
                            return -999;
                    }

                case UnitType.LbFtHr:
                    switch (toUnits)
                    {
                        case UnitType.Cp:
                            return value * 0.4133788732138;

                        default:
                            return -999;
                    }

                case UnitType.Cv:
                    switch (toUnits)
                    {
                        case UnitType.Kv:
                            return value * 0.865;
                        default:
                            return -999;
                    }

                case UnitType.Kv:
                    switch (toUnits)
                    {
                        case UnitType.Cv:
                            return value * 1.156;
                        default:
                            return -999;
                    }

                // ft3 to Current
                case UnitType.ft3:
                    switch (toUnits)
                    {
                        case UnitType.m3:
                            return value * 0.0283168466092305;

                        default:
                            return -999;
                    }

                // m3 to Current
                case UnitType.m3:
                    switch (toUnits)
                    {
                        case UnitType.ft3:
                            return value * 35.3146667;

                        default:
                            return -999;
                    }

                // Speed
                case UnitType.Rpm:
                case UnitType.MinNeg1:
                    switch (toUnits)
                    {
                        case UnitType.Rpm:
                        case UnitType.MinNeg1:
                            return value;

                        default:
                            return -999;
                    }

                default:
                    return -999;
            }
        }

  InchesToDn(value: number): number {
    if (value < 0) return -999;
    const ep = 0.001;
    if (Math.abs(value - 0) < ep) return 0;
    if (Math.abs(value - 0.125) < ep) return 6;
    if (Math.abs(value - 0.25) < ep) return 8;
    if (Math.abs(value - 0.375) < ep) return 10;
    if (Math.abs(value - 0.5) < ep) return 15;
    if (Math.abs(value - 0.75) < ep) return 20;
    if (Math.abs(value - 1) < ep) return 25;
    if (Math.abs(value - 1.25) < ep) return 32;
    if (Math.abs(value - 1.5) < ep) return 40;
    if (Math.abs(value - 2) < ep) return 50;
    if (Math.abs(value - 2.5) < ep) return 65;
    if (Math.abs(value - 3) < ep) return 80;
    if (Math.abs(value - 3.5) < ep) return 90;

    return Math.round(25 * value);
  }

  DnToInches(value: number): number {
    if (value < 0) return -999;
    const ep = 0.001;
    if (Math.abs(value - 0) < ep) return 0;
    if (Math.abs(value - 6) < ep) return 0.125;
    if (Math.abs(value - 8) < ep) return 0.25;
    if (Math.abs(value - 10) < ep) return 0.375;
    if (Math.abs(value - 15) < ep) return 0.5;
    if (Math.abs(value - 20) < ep) return 0.75;
    if (Math.abs(value - 25) < ep) return 1;
    if (Math.abs(value - 32) < ep) return 1.25;
    if (Math.abs(value - 40) < ep) return 1.5;
    if (Math.abs(value - 50) < ep) return 2;
    if (Math.abs(value - 65) < ep) return 2.5;
    if (Math.abs(value - 80) < ep) return 3;
    if (Math.abs(value - 90) < ep) return 3.5;

    return Math.round(value / 25);
  }
}